export class WorkDetailFormValues {

    _code;
    _name;
    _startDate;
    _endDate;
    _notes;
    _isActive;

    constructor(
        code,
        name,
        startDate,
        endDate,
        notes,
        isActive
    ) {
        this._code = code;
        this._name = name;
        this._startDate = startDate;
        this._endDate = endDate;
        this._notes = notes;
        this._isActive = isActive;
    }

    static fromWork(work) {
        return new this(
            work.code(),
            work.name(),
            work.startDate().date(),
            work.endDate().date(),
            work.notes(),
            work.isActive(),
        );
    }

    initialValues() {
        return {
            code: this._code,
            name: this._name,
            startDate: this._startDate,
            endDate: this._endDate,
            notes: this._notes,
            isActive: this._isActive,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/work/detail/WorkDetailFormValues.js